<script context="module">
    import { get } from "svelte/store";
    import { asaAllItemsList } from "../../../stores";
    import { cacheAsaItems } from "../../../Utils/utilCache.svelte";

    export const disableItemsMap = new Map([
        ["P7", ["CG850", "CG855", "CH946", "CH960"]],
    ]);

    // Missing add time code
    export const updateConsultItems = (
        item = {},
        selectedItems = [],
        itemProps = {},
    ) => {
        let res = [...selectedItems];

        const { id, infoRegion, itemCode } = item;

        const isCardiacEncounter = itemProps.billingType == 3;

        // const contradictoryItems = ["CA045", "CA070"];
        const contradictoryItems = [];
        const allowExistTogetherItemsMapArray = [["CA045", "CA070"]];
        const considerTimeItems = ["CA060", "CA080"];
        const notShowProceduresArr = ["CA080", "Telehealth"];
        const allowExistTogetherItemsMap = {
            CA045: ["CA002", "CA004", "CA006", "CA008"],
        };

        const hasConsultItemsSelected =
            selectedItems.length &&
            selectedItems.some((item) => item.infoType == "Consults");

        const _canItemsCoexist = (itemCode1, itemCode2) => {
            if (
                allowExistTogetherItemsMapArray.some(
                    (arr) => arr.includes(itemCode1) && arr.includes(itemCode2),
                )
            )
                return true;

            if (allowExistTogetherItemsMap[itemCode1]?.includes(itemCode2))
                return true;
            if (allowExistTogetherItemsMap[itemCode2]?.includes(itemCode1))
                return true;

            return false;
        };

        if (isCardiacEncounter) {
            const targetItem = get(asaAllItemsList).find(
                (item) => item.itemCode == itemCode,
            );

            if (!targetItem) return res;

            const toeContradictoryItems = ["CV730", "CV740"];

            const targetItemIsToeItem = toeContradictoryItems.includes(
                targetItem.itemCode,
            );
            const hasToeConsultItemSelected = selectedItems.some((itm) =>
                toeContradictoryItems.includes(itm.itemCode),
            );

            // remove all TOE consult items before adding new one
            if (targetItemIsToeItem && hasToeConsultItemSelected)
                res = selectedItems.filter(
                    (itm) => !toeContradictoryItems.includes(itm.itemCode),
                );

            const { infoType } = targetItem;

            if (!selectedItems.length) res = addItem(targetItem, res);
            else if (!selectedItems.some((itm) => itm.itemCode == itemCode)) {
                if (infoType != "Consults") {
                    res = addItem(targetItem, res);
                } else {
                    // Remove all consult items before adding new one
                    // res = selectedItems.filter(
                    //     (itm) => itm.infoType != "Consults",
                    // );
                    // res = addItem(targetItem, res);
                    selectedItems.forEach((existingItem) => {
                        if (
                            !_canItemsCoexist(
                                existingItem.itemCode,
                                targetItem.itemCode,
                            )
                        ) {
                            res = removeItem(existingItem, res);
                        }
                    });
                    res = addItem(targetItem, res);
                }
            } else if (item.infoType != "Cardiac")
                // Remove selected item not from quick-win options
                res = selectedItems.filter(
                    (itm) => itm.itemCode != item.itemCode,
                );
            else res = []; // Remove all items when consult type changes
        } else if (!hasConsultItemsSelected) res = addItem(item, res);
        else {
            const selectedConsultItems = selectedItems.filter(
                (item) => item.infoType == "Consults",
            );

            if (
                infoRegion != selectedConsultItems[0].infoRegion &&
                !_canItemsCoexist(
                    item.itemCode,
                    selectedConsultItems[0]?.itemCode,
                )
            ) {
                res = selectedItems.filter(
                    (item) => item.infoType != "Consults",
                );
                res = addItem(item, res);
            } else if (contradictoryItems.includes(itemCode)) {
                if (
                    selectedConsultItems.some((item) =>
                        contradictoryItems.includes(item.itemCode),
                    )
                ) {
                    const selectedContradictoryItem = selectedConsultItems.find(
                        (item) => contradictoryItems.includes(item.itemCode),
                    );
                    if (selectedContradictoryItem.id == id)
                        res = removeItem(item, res);
                    else {
                        res = removeItem(selectedContradictoryItem, res);
                        res = addItem(item, res);
                    }
                } else res = addItem(item, res);
            } else if (
                allowExistTogetherItemsMapArray.some((arr) =>
                    arr.includes(itemCode),
                )
            ) {
                const selectedItem = selectedItems.find(
                    (item) => item.id == id,
                );
                if (selectedItem) res = removeItem(selectedItem, res);
                else res = addItem(item, res);
            } else if (selectedItems.some((item) => item.id == id)) {
                const selectedItem = selectedItems.find(
                    (item) => item.id == id,
                );
                res = removeItem(selectedItem, res);
            } else {
                selectedConsultItems.forEach((existingItem) => {
                    if (!_canItemsCoexist(existingItem.itemCode, itemCode)) {
                        res = removeItem(existingItem, res);
                    }
                });
                res = addItem(item, res);
            }
        }

        if (
            res.some(
                ({ itemCode, infoRegion }) =>
                    notShowProceduresArr.includes(itemCode) ||
                    notShowProceduresArr.includes(infoRegion),
            )
        )
            res = res.filter(
                ({ infoType }) => infoType != "AdditionalProcedures",
            );

        if (res.some((item) => considerTimeItems.includes(item.itemCode)))
            console.error("should consider to add item code");

        return res;
    };

    // Missing add time code
    export const updateSurgeryItems = (
        item = {},
        selectedItems = [],
        itemProps = {},
        openNotification = () => {},
    ) => {
        let res = [...selectedItems];

        if (
            selectedItems.some(({ itemCode }) => disableItemsMap.has(itemCode))
        ) {
            const disabledItem = selectedItems.find(({ itemCode }) =>
                disableItemsMap.has(itemCode),
            );

            const conflictItems = disableItemsMap.get(disabledItem.itemCode);

            if (conflictItems.includes(item.itemCode)) {
                openNotification(item.itemCode, false);
                return res;
            }
        }

        const hasSurgeryItemsSelected =
            selectedItems.length &&
            selectedItems.some((item) => item.infoType == "Surgery");

        if (!hasSurgeryItemsSelected) res = addItem(item, res);
        else {
            const selectedItem = selectedItems.find(
                (item) => item.infoType == "Surgery",
            );
            if (selectedItem.id == item.id) res = removeItem(selectedItem, res);
            else {
                res = res.filter((item) => item.infoType != "Surgery");
                res = addItem(item, res);
            }
        }

        const { startDate, endDate } = itemProps;

        if (startDate && endDate) {
            const timeItem = selectedItems.find(
                (item) => item.itemCode == "Time",
            );

            if (timeItem) return res;

            const timeDiff = convertTimeRangeInMin(startDate, endDate);
            const targetTimeItemIndex = Math.floor(timeDiff / 15);
            const targetTimeItemDescription =
                getDescriptionByTime(targetTimeItemIndex);
            const targetTimeItem = {
                units: getTimeUnits(targetTimeItemIndex),
                amaUnits: getTimeUnits(targetTimeItemIndex),
                feeCharged: getTimeUnits(targetTimeItemIndex) * 100,
                rebateAMA: getTimeUnits(targetTimeItemIndex) * 100,
                encounterItemDescription: targetTimeItemDescription,
                itemCode: "Time",
            };

            return [...res, { ...targetTimeItem }];
        }

        return res;
    };

    export const updateModifierItems = (
        item = {},
        selectedItems = [],
        modifierMap = new Map(),
        openNotification = () => {},
    ) => {
        let res = [...selectedItems];

        if (disableItemsMap.has(item.itemCode)) {
            const conflictItems = disableItemsMap.get(item.itemCode);

            if (
                selectedItems.some((sItem) =>
                    conflictItems.includes(sItem.itemCode),
                )
            ) {
                openNotification(item.itemCode, true);
                return res;
            }
        }

        const hasModifierItemsSelect = selectedItems.some(
            (item) => item.infoType == "Modifiers",
        );

        if (!hasModifierItemsSelect) res = addItem(item, res);
        else {
            const { id, infoType, infoRegion } = item;
            const selectedModifierItems = selectedItems.filter(
                (item) => item.infoType == infoType,
            );
            const targetArrInMap = modifierMap.get(infoRegion);

            if (
                !selectedModifierItems.some((item) =>
                    targetArrInMap.some((itm) => item.itemCode == itm.itemCode),
                )
            )
                res = addItem(item, res);
            else if (infoRegion != "Other") {
                const selectedItem = selectedModifierItems.find(
                    (item) => item.infoRegion == infoRegion,
                );

                if (selectedItem) {
                    res = removeItem(selectedItem, res);
                    if (selectedItem.id != id) res = addItem(item, res);
                } else res = addItem(item, res);
            } else {
                if (selectedModifierItems.some((item) => item.id == id))
                    res = removeItem(item, res);
                else res = addItem(item, res);
            }
        }

        return res;
    };

    export const updateProcedureItems = (
        item = {},
        selectedItems = [],
        itemProps = {},
        defaultItems = [],
        holidaysInState = [],
        isFromSearch = false,
    ) => {
        let res = [...selectedItems];

        if (itemProps.billingType != 2)
            res = updateProcedureItemWithoutTimeCheck(
                item,
                selectedItems,
                defaultItems,
            );
        else
            res = updateProcedureItemsWithTimeCheck(
                item,
                selectedItems,
                itemProps,
                defaultItems,
                holidaysInState,
                isFromSearch,
            );

        return res;
    };

    export const updateTimeItems = (item = {}, selectedItems = []) => {
        let res = [...selectedItems];

        if (res.some((item) => item.itemCode == "Time"))
            res = res.filter((item) => item.itemCode != "Time");

        item.amaUnits = item.units;
        item.rebateAMA = item.feeCharged;

        res = [...res, item];

        return res;
    };

    export const updateNonCategoryItems = (item = {}, selectedItems = []) => {
        let res = [...selectedItems];

        const { itemCode, subItemCode } = item;

        if (
            res.some(
                (item) =>
                    item.itemCode == itemCode &&
                    item.subItemCode == subItemCode,
            )
        )
            res = removeItem(item, res);
        else res = addItem(item, res);

        return res;
    };

    export const getTimeUnits = (index) => {
        return index + 1;
    };

    export const getTimeItemsByUnits = (selectedItems = []) => {
        const timeItem = selectedItems.find((item) => item.itemCode == "Time");
        const { units } = timeItem;

        return units - 1;
    };

    export const getDescriptionByTime = (index) => {
        let gap = 15;

        let baseMin = 60;

        if (index == 0) return "15 MINUTES OR LESS";
        else if (index < 4) {
            const startMins = index * gap + 1;
            const endMins = (index + 1) * gap;
            return `${startMins} MINUTES TO ${endMins} MINUTES`;
        } else if (index < 8) gap = 15;
        else if (index < 20) {
            gap = 10;
            baseMin = 80;
        } else {
            gap = 5;
            baseMin = 160;
        }

        const startMins = baseMin + (index - 4) * gap + 1;
        const endMins = baseMin + (index - 3) * gap;

        const startTime = convertMinsToHours(startMins);
        const endTime = convertMinsToHours(endMins);

        return `${startTime} HOURS TO ${endTime} HOURS`;
    };

    const convertMinsToHours = (mins) => {
        const Hours = Math.floor(mins / 60);
        const Mins =
            Math.floor(mins % 60) > 9
                ? Math.floor(mins % 60)
                : "0" + Math.floor(mins % 60);

        return `${Hours}:${Mins}`;
    };

    const addItem = (item, arr) => {
        return [...arr, item];
    };

    const removeItem = (item, arr) => {
        return arr.filter((i) => i.id !== item.id);
    };

    const updateProcedureItemWithoutTimeCheck = (
        item,
        selectedItems,
        defaultItems,
    ) => {
        let res = [...selectedItems];

        const specialItemsMap = new Map([
            ["contradictoryItemsOne", ["CV085-0", "CV086-0"]],
            ["contradictoryItemsTwo", ["CV125-0", "CV126-0"]],
            // ["aliasItemsOne", ["CV025-0", "CV014-0"]],
            // ["aliasItemsTwo", ["CV020-0", "CV014-1"]],
            ["aliasItems", ["CV025", "CV014"]],
        ]);
        const contradictoryItemsOne = specialItemsMap.get(
            "contradictoryItemsOne",
        );
        const contradictoryItemsTwo = specialItemsMap.get(
            "contradictoryItemsTwo",
        );
        const aliasItemsOne = specialItemsMap.get("aliasItemsOne");
        const aliasItemsTwo = specialItemsMap.get("aliasItemsTwo");
        const aliasItems = specialItemsMap.get("aliasItems");

        const { itemCode, subItemCode } = item;
        const combinedKey = `${itemCode}-${subItemCode}`;

        if (contradictoryItemsOne.includes(combinedKey))
            res = updateProcedureWithContradictory(
                item,
                selectedItems,
                contradictoryItemsOne,
                combinedKey,
            );
        else if (contradictoryItemsTwo.includes(combinedKey))
            res = updateProcedureWithContradictory(
                item,
                selectedItems,
                contradictoryItemsTwo,
                combinedKey,
            );
        // else if (aliasItemsOne[0] == combinedKey) {
        //     res = updateProcedureWithAlias(
        //         item,
        //         selectedItems,
        //         aliasItemsOne,
        //         defaultItems,
        //     );
        // } else if (aliasItemsTwo[0] == combinedKey) {
        //     res = updateProcedureWithAlias(
        //         item,
        //         selectedItems,
        //         aliasItemsTwo,
        //         defaultItems,
        //     );
        else if (aliasItems.includes(itemCode))
            res = updateProcedureWithAlias(
                item,
                selectedItems,
                aliasItems,
                defaultItems,
            );
        else if (
            selectedItems.some(
                (item) =>
                    item.itemCode == itemCode &&
                    item.subItemCode == subItemCode,
            )
        )
            res = removeItem(item, res);
        else res = addItem(item, res);

        return res;
    };

    const updateProcedureWithContradictory = (
        item = {},
        selectedItems = [],
        contradictoryArr = [],
        combinedKey = "",
    ) => {
        let res = [...selectedItems];

        const contradictoryItemCode = contradictoryArr.find(
            (key) => combinedKey != key,
        );

        if (
            res.some(
                ({ itemCode, subItemCode }) =>
                    `${itemCode}-${subItemCode}` == contradictoryItemCode,
            )
        ) {
            const replaceItem = res.find(
                ({ itemCode, subItemCode }) =>
                    `${itemCode}-${subItemCode}` == contradictoryItemCode,
            );
            res = removeItem(replaceItem, res);
            res = addItem(item, res);
        } else if (res.some((itm) => itm.itemCode == item.itemCode))
            res = removeItem(item, res);
        else res = addItem(item, res);

        return res;
    };

    const updateProcedureWithAlias = (
        item = {},
        selectedItems = [],
        aliasArr = [],
        defaultItems = [],
    ) => {
        let res = [...selectedItems];

        // aliasArr ["CV020", "CV014"]

        const { itemCode, subItemCode } = item;
        const aliasItemCode = aliasArr[1];
        const aliasItem = defaultItems.find(
            ({ itemCode, subItemCode }) =>
                itemCode == aliasItemCode && subItemCode == item.subItemCode,
        );

        if (
            !res.length ||
            !selectedItems.some(
                (item) =>
                    item.itemCode == itemCode &&
                    item.subItemCode == subItemCode,
            )
        ) {
            res = addItem(item, res);
            if (
                aliasItem &&
                !res.some(
                    (item) =>
                        item.itemCode == aliasItem.itemCode &&
                        item.subItemCode == aliasItem.subItemCode,
                )
            )
                res = addItem(aliasItem, res);
        } else if (
            selectedItems.some(
                (item) =>
                    item.itemCode == itemCode &&
                    item.subItemCode == subItemCode,
            )
        ) {
            res = removeItem(item, res);
            if (aliasItem) res = removeItem(aliasItem, res);
        }

        return res;
    };

    const updateProcedureItemsWithTimeCheck = (
        item,
        selectedItems,
        itemProps,
        defaultItems,
        holidaysInState,
        isFromSearch,
    ) => {
        let res = [...selectedItems];

        const { startDate, endDate } = itemProps;

        if (!startDate || !endDate) return res;

        const specialItemsForOverHalf = ["CV120", "CV122"];
        const specialItemsForLessHalf = ["CV123", "CV124"];
        const specialItemsInKeyOne = ["CV120", "CV123"];
        const specialItemsInKeyTwo = ["CV125", "CV126"];

        if (isFromSearch) {
            const containsNeuraxialInsertion =
                specialItemsForOverHalf.includes(item.itemCode) ||
                specialItemsForLessHalf.includes(item.itemCode);
            const containsNeuraxialTopUp = specialItemsInKeyTwo.includes(
                item.itemCode,
            );
            if (containsNeuraxialInsertion && containsNeuraxialTopUp)
                itemProps.neuraxialType = 3;
            else if (containsNeuraxialInsertion) item = { ...item, key: 1 };
            else if (containsNeuraxialTopUp) item = { ...item, key: 2 };
        }

        const timeDiff = convertTimeRangeInMin(startDate, endDate);
        const overlapMins = getOverlapMins(
            startDate,
            endDate,
            holidaysInState,
            itemProps,
        );
        const overlapPercentage = Math.round((overlapMins / timeDiff) * 100);

        if (item?.key == 1) {
            // INSERTION
            if (timeDiff <= 60) {
                const targetItem =
                    overlapPercentage > 50
                        ? defaultItems.find(
                              ({ itemCode }) =>
                                  itemCode == specialItemsInKeyOne[0],
                          )
                        : defaultItems.find(
                              ({ itemCode }) =>
                                  itemCode == specialItemsInKeyOne[1],
                          );

                if (!targetItem) return res;

                targetItem.key = item.key;

                if (
                    selectedItems.some(
                        (item) => item.itemCode == targetItem.itemCode,
                    )
                )
                    res = removeItem(targetItem, res);
                else if (
                    selectedItems.some(
                        ({ infoType }) => infoType == "AdditionalProcedures",
                    ) &&
                    itemProps.neuraxialType != 3
                ) {
                    selectedItems.map((item) => {
                        if (item.infoType == "AdditionalProcedures")
                            res = removeItem(item, res);
                    });
                    res = addItem(targetItem, res);
                } else res = addItem(targetItem, res);
            } else {
                const targetItems =
                    overlapPercentage > 50
                        ? defaultItems.filter(({ itemCode }) =>
                              specialItemsForOverHalf.includes(itemCode),
                          )
                        : defaultItems.filter(({ itemCode }) =>
                              specialItemsForLessHalf.includes(itemCode),
                          );

                if (!targetItems.length) return res;

                const hasFirstItem = selectedItems.find(
                    ({ itemCode }) => itemCode == targetItems[0].itemCode,
                );

                const hasSecondItem = selectedItems.find(
                    ({ itemCode }) => itemCode == targetItems[1].itemCode,
                );

                if (hasFirstItem && hasSecondItem) {
                    res = removeItem(targetItems[0], res);
                    res = removeItem(targetItems[1], res);
                } else if (hasFirstItem) res = addItem(targetItems[1], res);
                else if (hasSecondItem) res = addItem(targetItems[0], res);
                else if (
                    selectedItems.some(
                        ({ infoType }) => infoType == "AdditionalProcedures",
                    ) &&
                    itemProps.neuraxialType != 3
                ) {
                    selectedItems.map((item) => {
                        if (item.infoType == "AdditionalProcedures")
                            res = removeItem(item, res);
                    });
                    res = addItem(targetItems[0], res);
                    res = addItem(targetItems[1], res);
                } else {
                    res = addItem(targetItems[0], res);
                    res = addItem(targetItems[1], res);
                }
            }
        } else if (item?.key == 2) {
            // TOP UP
            const targetItem =
                timeDiff <= 15
                    ? defaultItems.find(
                          ({ itemCode }) => itemCode == specialItemsInKeyTwo[0],
                      )
                    : defaultItems.find(
                          ({ itemCode }) => itemCode == specialItemsInKeyTwo[1],
                      );

            if (
                selectedItems.some(
                    ({ itemCode }) => itemCode == targetItem.itemCode,
                )
            )
                res = removeItem(targetItem, res);
            else if (
                selectedItems.some(
                    ({ infoType }) => infoType == "AdditionalProcedures",
                ) &&
                itemProps.neuraxialType != 3
            ) {
                selectedItems.map((item) => {
                    if (item.infoType == "AdditionalProcedures")
                        res = removeItem(item, res);
                });
                res = addItem(targetItem, res);
            } else res = addItem(targetItem, res);
        } else if (itemProps.neuraxialType == 3 && !item?.key) {
            if (
                selectedItems.some(
                    ({ infoType }) => infoType == "AdditionalProcedures",
                )
            ) {
                selectedItems.map((item) => {
                    if (item.infoType == "AdditionalProcedures")
                        res = removeItem(item, res);
                });
            }

            // BOTH INSERTION AND TOPUP ARE SELECTED
            if (timeDiff <= 60) {
                const targetItem =
                    overlapPercentage > 50
                        ? defaultItems.find(
                              ({ itemCode }) =>
                                  itemCode == specialItemsInKeyOne[0],
                          )
                        : defaultItems.find(
                              ({ itemCode }) =>
                                  itemCode == specialItemsInKeyOne[1],
                          );

                if (!targetItem) return res;

                res = addItem(targetItem, res);
            } else {
                const targetItems =
                    overlapPercentage > 50
                        ? defaultItems.filter(({ itemCode }) =>
                              specialItemsForOverHalf.includes(itemCode),
                          )
                        : defaultItems.filter(({ itemCode }) =>
                              specialItemsForLessHalf.includes(itemCode),
                          );

                if (!targetItems.length) return res;

                res = addItem(targetItems[0], res);
                res = addItem(targetItems[1], res);
            }

            const targetItem =
                timeDiff <= 15
                    ? defaultItems.find(
                          ({ itemCode }) => itemCode == specialItemsInKeyTwo[0],
                      )
                    : defaultItems.find(
                          ({ itemCode }) => itemCode == specialItemsInKeyTwo[1],
                      );

            res = addItem(targetItem, res);
        }

        return res;
    };

    const convertTimeRangeInMin = (start, end) => {
        const startTime = new Date(start);
        const endTime = new Date(end);

        return (endTime - startTime) / (1000 * 60);
    };

    const getOverlapMins = (start, end, holidaysInState, itemProps) => {
        const workStartTime = new Date(start);
        const workEndTime = new Date(start);
        const startTime = new Date(start);
        const endTime = new Date(end);

        // normal operating hours 8am - 6pm, otherwise is after hours
        workStartTime.setHours(8, 0, 0, 0);
        workEndTime.setHours(18, 0, 0, 0);

        // all weekends are after hours
        const { scheduledDate } = itemProps;
        if (
            new Date(scheduledDate).getDay() == 0 ||
            new Date(scheduledDate).getDay() == 6
        )
            return 0;

        const startDate = start.split("T")[0] + "T00:00:00";

        if (holidaysInState.some((holiday) => holiday.date == startDate))
            return 0;

        const maxStart = Math.max(startTime, workStartTime);
        const minEnd = Math.min(endTime, workEndTime);

        if (maxStart >= minEnd) return 0;

        return Math.round((minEnd - maxStart) / (1000 * 60));
    };

    export const searchAsaItems = async (searchText) => {
        if (!get(asaAllItemsList).length) await cacheAsaItems();

        const allItems = get(asaAllItemsList);

        searchText = searchText.toString().toLowerCase();

        return allItems.filter(
            (item) =>
                item.itemCode.toLowerCase().includes(searchText) ||
                item.infoShortTitle.toLowerCase().includes(searchText) ||
                item.infoRegion.toLowerCase().includes(searchText) ||
                item.infoSubRegion.toLowerCase().includes(searchText) ||
                item.description.toLowerCase().includes(searchText),
        );
    };

    export const getCardiacAsaCodes = () => [
        {
            itemCode: "CA002",
            subItemCode: "0",
            infoType: "Cardiac",
            infoRegion: "Anaesthesia",
            infoSubRegion: "Pre-anaesthesia consults",
            infoShortTitle: "<15 mins",
        },
        {
            itemCode: "CA004",
            subItemCode: "0",
            infoType: "Cardiac",
            infoRegion: "Anaesthesia",
            infoSubRegion: "Pre-anaesthesia consults",
            infoShortTitle: "16-30 mins",
        },
        {
            itemCode: "CA006",
            subItemCode: "0",
            infoType: "Cardiac",
            infoRegion: "Anaesthesia",
            infoSubRegion: "Pre-anaesthesia consults",
            infoShortTitle: "31-45 mins",
        },
        {
            itemCode: "CA008",
            subItemCode: "0",
            infoType: "Cardiac",
            infoRegion: "Anaesthesia",
            infoSubRegion: "Pre-anaesthesia consults",
            infoShortTitle: "46+ mins",
        },
        {
            itemCode: "CA051",
            subItemCode: "0",
            infoType: "Cardiac",
            infoRegion: "Anaesthesia",
            infoSubRegion: "Pre-anaesthesia consults",
            infoShortTitle: "Emergency After-Hours",
        },
        {
            itemCode: "CA070",
            subItemCode: "0",
            infoType: "Cardiac",
            infoRegion: "Anaesthesia",
            infoSubRegion: "Pre-anaesthesia consults",
            infoShortTitle: "Call-back",
        },
        {
            itemCode: "CV060",
            subItemCode: "0",
            infoType: "Cardiac",
            infoRegion: "Perfusion",
            infoSubRegion: "",
            infoShortTitle: "Bypass",
        },
        {
            itemCode: "CV055",
            subItemCode: "0",
            infoType: "Cardiac",
            infoRegion: "ECMO",
            infoSubRegion: "",
            infoShortTitle: "ECMO",
        },
        {
            itemCode: "CV076",
            subItemCode: "0",
            infoType: "Cardiac",
            infoRegion: "Perfusion standby",
            infoSubRegion: "",
            infoShortTitle: "Standby",
        },
        {
            itemCode: "CV730",
            subItemCode: "0",
            infoType: "Cardiac",
            infoRegion: "TOE",
            infoSubRegion: "",
            infoShortTitle: "TOE",
        },
        {
            itemCode: "CV740",
            subItemCode: "0",
            infoType: "Cardiac",
            infoRegion: "TOE",
            infoSubRegion: "",
            infoShortTitle: "TOE Doppler",
        },
    ];

    export const hasCardiacAsaCode = (selectedItems = []) => {
        if (!selectedItems) return false;

        const cardiacConsultItems = getCardiacAsaCodes();

        return selectedItems.some((item) =>
            cardiacConsultItems.some((itm) => itm.itemCode == item.itemCode),
        );
    };

    export const getCardiacAdditionalProcedureQuickWins = (
        selectedItems = [],
    ) => {
        if (!selectedItems) return [];

        if (
            selectedItems.some(({ itemCode }) =>
                ["CD560", "CD565", "CD570", "CD580", "CD582", "CD584"].includes(
                    itemCode,
                ),
            )
        )
            return [
                { key: "CV740-0", value: "TOE Doppler" },
                { key: "CV025-0", value: "Art Line" },
                { key: "CV014-0", value: "Art monitor" },
                { key: "CV020-0", value: "CVC Line" },
                { key: "CV014-1", value: "CVC monitor" },
                { key: "CV015-0", value: "PAC" },
                { key: "CV014-2", value: "PAC monitor" },
                { key: "CV800-0", value: "US for vascular access" },
                { key: "CV085-0", value: "Neuraxial analgesia initial" },
                { key: "CV007-0", value: "Fibreoptic intubation " },
                { key: "CV008-0", value: "Lung isolation" },
                { key: "CV002-0", value: "Blood transfusion" },
                { key: "CV003-0", value: "Massive blood transfusion" },
                { key: "CV001-0", value: "Blood collection" },
                { key: "CV009-0", value: "EEG monitor" },
            ];

        if (selectedItems.some(({ itemCode }) => itemCode == "CV060"))
            return [
                { key: "CV065-0", value: "Hypothermia" },
                { key: "CV075-0", value: "Hypothermia < 22C" },
                { key: "CV070-0", value: "Cardioplegia" },
                { key: "CV740-0", value: "TOE Doppler" },
                { key: "CV025-0", value: "Art Line" },
                { key: "CV014-0", value: "Art monitor" },
                { key: "CV020-0", value: "CVC Line" },
                { key: "CV014-1", value: "CVC monitor" },
                { key: "CV015-0", value: "PAC" },
                { key: "CV014-2", value: "PAC monitor" },
                { key: "CV800-0", value: "US for vascular access" },
                { key: "CV085-0", value: "Neuraxial analgesia initial" },
                { key: "CV007-0", value: "Fibreoptic intubation " },
                { key: "CV008-0", value: "Lung isolation" },
                { key: "CV002-0", value: "Blood transfusion" },
                { key: "CV003-0", value: "Massive blood transfusion" },
                { key: "CV001-0", value: "Blood collection" },
                { key: "CV009-0", value: "EEG monitor" },
            ];

        return [
            { key: "CV025-0", value: "Art Line" },
            { key: "CV014-0", value: "Art monitor" },
            { key: "CV020-0", value: "CVC Line" },
            { key: "CV014-1", value: "CVC monitor" },
            { key: "CV800-0", value: "US for vascular access" },
            { key: "CV081-0", value: "Major nerve block" },
            { key: "CV083-0", value: "Major nerve block with catheter" },
            { key: "CV082-0", value: "Minor nerve block" },
            { key: "CV805-0", value: "US for nerve block" },
            { key: "CV084-0", value: "Eye block" },
            { key: "CV085-0", value: "Neuraxial analgesia(initial)" },
            { key: "CV086-0", value: "Neuraxial analgesia(top-up)" },
            { key: "CV007-0", value: "Fibreoptic intubation" },
            { key: "CV008-0", value: "Lung isolation" },
            { key: "CV002-0", value: "Blood Transfusion" },
            { key: "CV003-0", value: "Massive blood transfusion" },
            { key: "CV001-0", value: "Blood collection" },
            { key: "CV009-0", value: "EEG monitor" },
        ];
    };

    export const getAsaItemCodeLabel = (item) => {
        const { itemCode } = item;

        if (!itemCode) return "";

        return `${itemCode}:`;
    };
</script>
